import { render } from "./Welcome_2.vue?vue&type=template&id=53b56fd0&scoped=true"
import script from "./Welcome_2.vue?vue&type=script&lang=js"
export * from "./Welcome_2.vue?vue&type=script&lang=js"

import "./Welcome_2.vue?vue&type=style&index=0&id=53b56fd0&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b56fd0"]])

export default __exports__